import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import DiscountPlanCreateForm from "./create";
import DiscountPlanEditForm from "./edit";
import {
  deleteDiscountPlan,
  getDiscountPlanDetails,
  getDiscountPlans,
} from "src/store/contract-discountplans/saga";
import {
  DiscountPlanDetailDto,
  DiscountPlanDto,
} from "src/store/contract-discountplans/type";
const DiscountPlanesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<DiscountPlanDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<DiscountPlanDetailDto>();
  const columns = [
    {
      text: t("Contract.DiscountPlan.Name"),
      dataField: "Name",
    },
    {
      text: t("Contract.DiscountPlan.Value"),
      dataField: "Value",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.DiscountPlan.PageTitle")}
        metaTag={t("Contract.DiscountPlan.MetaTag")}
        gridProps={{
          addTitle: t("Contract.DiscountPlan.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getDiscountPlans,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getDiscountPlanDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: DiscountPlanDto) =>
              t("Contract.DiscountPlan.DeleteQA", {
                name: data.Name,
              }),
            action: deleteDiscountPlan,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <DiscountPlanCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getDiscountPlans,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <DiscountPlanEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getDiscountPlans,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default DiscountPlanesPage;
